import { motion } from "framer-motion";
import { Reveal, Eyebrow, EASE } from "./Reveal";

const STEPS = [
  { n: "01", title: "Discovery", text: "Understand your business, users and requirements." },
  { n: "02", title: "Strategy", text: "Define the product scope, features and technology architecture." },
  { n: "03", title: "UI/UX Design", text: "Create intuitive and professional user experiences." },
  { n: "04", title: "Development", text: "Build the website, software, SaaS or mobile application." },
  { n: "05", title: "Testing", text: "Test functionality, performance, responsiveness and security." },
  { n: "06", title: "Launch & Support", text: "Deploy the product and provide ongoing technical support." },
];

export const Process = () => (
  <section id="process" className="bg-white py-24 sm:py-32" data-testid="process-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
        <div>
          <Eyebrow>Our Process</Eyebrow>
          <h2 className="mt-5 font-jakarta text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl" data-testid="process-heading">
            From Idea to Digital Product
          </h2>
        </div>
        <p className="max-w-sm font-inter text-sm leading-relaxed text-slate-500">
          A clear, transparent delivery process — so you always know what happens next.
        </p>
      </Reveal>

      <div className="relative mt-16">
        <motion.div
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.6, ease: EASE }}
          className="absolute left-0 top-6 hidden h-px w-full origin-left bg-gradient-to-r from-gold via-magenta/60 to-slate-200 lg:block"
        />
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-6 lg:gap-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.1}>
              <div className="group relative" data-testid={`process-step-${s.n}`}>
                <div className="flex items-center gap-4 lg:block">
                  <span className="relative z-10 flex h-12 w-12 items-center justify-center rounded-full border border-gold/40 bg-white font-mono2 text-[13px] font-semibold text-gold transition-colors duration-300 group-hover:bg-navy group-hover:text-gold-light group-hover:border-navy">
                    {s.n}
                  </span>
                  <span className="hidden flex-1 border-t border-dashed border-slate-200 lg:hidden" />
                </div>
                <h3 className="mt-5 font-jakarta text-[15px] font-bold text-navy">{s.title}</h3>
                <p className="mt-1.5 font-inter text-[12.5px] leading-relaxed text-slate-500">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
